import React, { ChangeEvent, useState } from 'react';

type Event = ChangeEvent<HTMLInputElement>;

interface TextFieldProps {
  onChange?: (event: Event) => void,
  onBlur?: (event: Event) => void,
  textarea?: boolean
  id?: string,
  value: string,
  type?: string,
  className?: string,
  restrictInput?: (value: string | number) => boolean,
  validateInput?: (value: string | number) => boolean,
  'data-locator'?: string,
  fieldProps?: React.InputHTMLAttributes<HTMLInputElement> | React.InputHTMLAttributes<HTMLTextAreaElement>
}

export const TextField = (props: TextFieldProps) => {
  const [validity, setValidity] = useState(props.validateInput ? props.validateInput(props.value) : true);

  const classes = `text-base font-semibold rounded-md shadow-md p-2 border-2 border-gray-300 hover:border-gray-400 hover:border-black ${props.className ? props.className : ''} `;
  const invalidClasses = 'border-red-200';

  const fieldProps = {
    ...props.fieldProps ? props.fieldProps : {},
    onChange: (event: Event) => {
      if (props.restrictInput && !props.restrictInput(event.target.value)) {
        event.preventDefault();
        return;
      }
      props.validateInput && setValidity(props.validateInput(event.target.value));
      props.onChange && props.onChange(event);
    },
    onBlur: props.onBlur,
    value: props.value,
    id: props.id,
    'data-locator': props['data-locator'],
  };

  if (props.textarea) {
    return <textarea
      {...(fieldProps as unknown as React.InputHTMLAttributes<HTMLTextAreaElement>)}
      className={classes + (validity ? '' : invalidClasses)}/>;
  } 
  return <input {...fieldProps as React.InputHTMLAttributes<HTMLInputElement>} className={classes + (validity ? '' : invalidClasses)}/>;
};


